import script from "./RedemptionCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./RedemptionCode.vue?vue&type=script&setup=true&lang=ts"

import "./RedemptionCode.vue?vue&type=style&index=0&id=3c150a85&scoped=true&lang=css"
script.__scopeId = "data-v-3c150a85"

export default script